import React, { createElement, Fragment, useRef, useImperativeHandle, useEffect, useState, forwardRef, } from 'react';
import { Step, Box, Button } from '@alifd/next';
import './index.scss';
function renderStep(props, formArray, step, formArrayRef, setStep) {
    const { direction = 'hoz', children, showAll, ...others } = props;
    if (direction === 'hoz') {
        return (createElement("div", { className: "step-form steps" }, formArray && (createElement(Step, { direction: direction, ...others, current: step }, Array.from(formArray.keys()).map((item) => {
            const { stepItemProps } = formArray.get(item);
            return (createElement(Step.Item, { key: item, ...stepItemProps, onClick: (clickStep) => stepItemClick(step, clickStep, setStep, formArrayRef) }));
        })))));
    }
    return (createElement("div", { className: "step-form steps" },
        createElement(Step, { direction: direction, ...others, current: step }, React.Children.map(children, (child, index) => {
            const { stepItemProps } = formArray.get(`${index}`);
            const content = (createElement("div", { className: "step-form forms", style: { display: showAll || step === index ? 'block' : 'none' } }, React.cloneElement(child, {
                ref: (node) => {
                    formArrayRef.current[index] = node;
                    const { ref } = child;
                    if (typeof ref === 'function') {
                        ref(node);
                    }
                },
            })));
            return createElement(Step.Item, { content: content, key: index, ...stepItemProps });
        }))));
}
function renderForm(props, step, formArrayRef) {
    const { children } = props;
    return (createElement(Fragment, null, React.Children.map(children, (child, index) => {
        return (createElement("div", { className: "step-form forms", style: { display: step === index ? 'block' : 'none' } }, React.cloneElement(child, {
            ref: (node) => {
                formArrayRef.current[index] = node;
                const { ref } = child;
                if (typeof ref === 'function') {
                    ref(node);
                }
            },
        })));
    })));
}
const stepItemClick = async (currentStep, clickStep, setStep, formArrayRef) => {
    await validateTargetStep(currentStep, setStep, formArrayRef, clickStep);
};
const onPrevious = (step, setStep) => {
    setStep(Math.max(0, --step));
};
const validateTargetStep = async (currentStep, setStep, formArrayRef, targetStep) => {
    const currentFormRef = formArrayRef.current[currentStep];
    const formField = currentFormRef.getInstance()?._formField;
    await formField.validate((errors) => {
        if (!errors) {
            setStep(targetStep);
        }
    });
};
const onNext = (step, setStep, stepLength, formArrayRef) => {
    validateTargetStep(step, setStep, formArrayRef, Math.min(stepLength - 1, ++step));
};
const renderOperations = ({ step, setStep, stepLength, formArrayRef }) => {
    return (createElement("div", { className: "step-form operations" },
        createElement(Button.Group, null,
            createElement(Button, { type: "secondary", disabled: step === 0, onClick: () => onPrevious(step, setStep) }, "\u4E0A\u4E00\u6B65"),
            createElement(Button, { type: "primary", disabled: step === stepLength - 1, onClick: () => onNext(step, setStep, stepLength, formArrayRef) }, "\u4E0B\u4E00\u6B65"),
            step === stepLength - 1 && (createElement(Button, { type: "primary" }, "\u4FDD\u5B58")))));
};
function CbayelStepForm(props, ref) {
    const { children, formRef, formMapRef: propsFormMapRef, direction = 'hoz' } = props;
    const [step, setStep] = useState(props.current);
    const formArrayRef = useRef([]);
    useImperativeHandle(propsFormMapRef, () => formArrayRef.current);
    const currentFormRef = formArrayRef.current[step || 0]?.current;
    useImperativeHandle(formRef, () => currentFormRef);
    const formArray = new Map();
    React.Children.map(children, (child, index) => {
        const itemProps = child.props;
        const name = `${index}`;
        formArray.set(name, itemProps);
    });
    useEffect(() => {
        setStep(props.current);
    }, [props.current]);
    if (!children) {
        return (createElement(Box, { ref: ref, align: "center", justify: "center", style: { minHeight: 50 } },
            createElement("span", null, "\u5185\u5BB9\u4E3A\u7A7A")));
    }
    return (createElement("div", { ref: ref },
        createElement(Fragment, null, renderStep(props, formArray, step, formArrayRef, setStep)),
        createElement(Fragment, null, direction === 'hoz' ? renderForm(props, step, formArrayRef) : null),
        renderOperations({
            step,
            setStep,
            stepLength: formArray.size,
            formArrayRef,
        })));
}
export default forwardRef(CbayelStepForm);
